import { LectureId } from '../curriculum/types/lecture-interface'
import { ModuleId } from '../curriculum/types/module-interface'
import { CourseId } from '../types/course-interface'

export const LIGHT_COURSE_API = '/api/dashboard/customer/membership/light-editor/course'

export const getLightCourseCurriculumPath = (courseId: CourseId) =>
  `${LIGHT_COURSE_API}/${courseId}/curriculum`

export const LIGHT_COURSES_LIST_ALL_API = `${LIGHT_COURSE_API}s/list-all`

export const CREATE_LIGHT_COURSE_API = `${LIGHT_COURSE_API}/create`

export const getLightCoursePatchOptionsPath = (courseId: CourseId) =>
  `${LIGHT_COURSE_API}/${courseId}/options`

export const getLightCourseCreateModulePath = (courseId: CourseId) =>
  `${LIGHT_COURSE_API}/${courseId}/create-module`

export const getLightCourseCreateLecturePath = (moduleId: ModuleId) =>
  `/api/dashboard/customer/membership/light-editor/module/${moduleId}/create-lecture`

export const getLightCourseUpdateLecturePath = (lectureId: LectureId) => {
  return `/api/dashboard/customer/membership/light-editor/lecture/${lectureId}`
}

export const getLightCourseDeleteLecturePath = (lectureId: LectureId) => {
  return `/api/dashboard/customer/membership/light-editor/lecture/${lectureId}`
}

export const getLightCourseGetLecturePath = (lectureId: LectureId) => {
  return `/api/dashboard/customer/membership/light-editor/lecture/${lectureId}`
}

export const getLightCourseUpdateModulePath = (moduleId: ModuleId) => {
  return `/api/dashboard/customer/membership/light-editor/module/${moduleId}`
}
